import React from 'react';
import PropTypes from 'prop-types';

import '../styles/index.scss';

export const ToggleSwitch = function (props) {
  let classNames = ['ToggleSwitch', props.isChecked ? 'ToggleSwitch__on' : ''].join(' ');

  return (
    <div className="ToggleSwitchContainer">
      <div className={classNames} onClick={props.onClick}>
        <ToggleButton isChecked={props.isChecked} />
      </div>
      <div className={`${props.isChecked ? 'ToggleSwitch__label selected' : 'ToggleSwitch__label'}`}>{props.label}</div>
    </div>
  );
};

export const ToggleButton = function (props) {
  let classNames = ['ToggleButton', props.isChecked ? 'ToggleButton__selected' : ''].join(' ');

  return <div className={classNames} />;
};

ToggleSwitch.propTypes = {
  isChecked: PropTypes.bool,
  onClick: PropTypes.func,
};

ToggleSwitch.defaultProps = {
  isChecked: false,
  onClick: () => {
    //
  },
};
